import React, { useState } from 'react'
import Loader from "../components/Loader";
import Error from "../components/Error";
import Success from '../components/Success'
import axios from "axios";

function Register() {
	const [loading, setloading] = useState(false);
	const [error, seterror] = useState();
	const [success, setsuccess] = useState();
    const [name,setname]=useState('')
      const [email, setemail] = useState('');
        const [password, setpassword] = useState('');
          const [confirmpassword, setconfirmpassword] = useState('');

         async function Submit(){
            if(password === confirmpassword){
const user={ 
    name,
    email,
    password,
    confirmpassword,
}

try {
	setloading(true);
	const result = await axios.post("https://online-hotels-booking-system-server.vercel.app/api/users/register", user)

		.then((response) => {
			
		
			console.log(response.data);
		});
			setloading(false);
			setsuccess(true)
			setname('')
			setemail('')
			setconfirmpassword('')
			setpassword('')

} catch (error) {
	seterror(true);
	console.log(error);
	setloading(false);
}

console.log(user)
            }else{
                alert('Password not Match')
            }
          }


  return (
		<div>
			{loading && <Loader />}
			{error && <Error />}

			<div className="row justify-content-center mt-5">
				<div className="col-md-5">
					{success && <Success massage='Registration Successful' />}
					<div className="bs">
						<h1>Register</h1>
						<input
							type="text"
							className="form-control"
							placeholder="name"
							value={name}
							onChange={(e) => {
								setname(e.target.value);
							}}
						/>
						<input
							type="email"
							className="form-control"
							placeholder="email"
							value={email}
							onChange={(e) => {
								setemail(e.target.value);
							}}
						/>
						<input
							type="password"
							className="form-control"
							placeholder="password"
							value={password}
							onChange={(e) => {
								setpassword(e.target.value);
							}}
						/>
						<input
							type="password"
							className="form-control"
							placeholder="confirm password"
							value={confirmpassword}
							onChange={(e) => {
								setconfirmpassword(e.target.value);
							}}
						/>

						<button className="btn btn-primary mt-3" onClick={Submit}>
							Register
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Register